module.exports = __webpack_public_path__ + "img/cropped-owl@4x-192x192.c3c1b715.png";